import React, { Component} from 'react';
import './Pubs.css';
import { IconContext } from "react-icons";
import { BiChevronLeft, BiSidebar } from "react-icons/bi";


class Pubs extends Component {
  constructor(props) {
    super(props);

    this.state = {
      
    };
  }

  componentDidUpdate(){
    
  }
 
  componentDidMount(){
    
  }

  render() {
    return (
      <div className = "pubPage pubScrollableSec">
        <div className = "pubSection">
          <div className = "pubLabel">
            <h3>2024</h3>
          </div>
          <div className = "pubPubs">
            <p> <strong>How We See Changes How We Feel: Investigating the Effect of Visual Point-of-View on Decision-Making in VR Environments </strong>
              <br></br><em>Michael Yin and Robert Xiao</em>
              <br></br>CSCW 2024 [<a href="https://www.mikeyin.xyz/files/CSCW394.pdf" target="_blank">preprint</a>]
            </p>
            <p> <strong>Press A or Wave: User Expectations for NPC Interactions and Nonverbal Behaviour in Virtual Reality </strong>
              <br></br><em>Michael Yin and Robert Xiao</em>
              <br></br>CHI PLAY 2024 [<a href="https://www.mikeyin.xyz/files/CHIPLAY333.pdf" target="_blank">preprint</a>]
            </p>
            <p> <strong>VirtualNexus: Enhancing 360-Degree Video AR/VR Collaboration with Environment Cutouts and Virtual Replicas </strong>
              <br></br><em>Xincheng Huang*, Michael Yin*, Ziyi Xia, and Robert Xiao</em>
              <br></br>UIST 2024 [<a href="https://arxiv.org/pdf/2408.02914" target="_blank">preprint</a>]
            </p>
            <p> <strong>Lies, Deceit, and Hallucinations: Player Perception and Expectations Regarding Trust and Deception in Games </strong>
              <br></br><em>Michael Yin, Emi Wang, Chuoxi Ng, and Robert Xiao</em>
              <br></br>CHI 2024 [<a href="https://dl.acm.org/doi/10.1145/3613904.3642253" target="_blank">pdf</a>]
            </p>
          </div>
          <div className = "pubLabel">
            <h3>2023</h3>
          </div>
          <div className = "pubPubs">
            <p> <strong>SurfShare: Lightweight Spatially Consistent Physical Surface and Virtual Replica Sharing with Head-mounted Mixed-Reality </strong>
              <br></br><em>Xincheng Huang and Robert Xiao</em>
              <br></br>IMWUT 2023 [<a href="https://dl.acm.org/doi/10.1145/3631418" target="_blank">pdf</a>]
            </p>
            <p> <strong>Virtual Reality Telepresence: 360-Degree Video Streaming with Edge-Compute Assisted Static Foveated Compression </strong>
              <br></br><em>Xincheng Huang, James Riddell, and Robert Xiao</em>
              <br></br>IEEE Transactions on Visualization and Computer Graphics 2023 [<a href="https://ieeexplore.ieee.org/document/10269640" target="_blank">pdf</a>]
            </p>
            <p> <strong>Drifting Off in Paradise: Why People Sleep in Virtual Reality </strong>
              <br></br><em>Michael Yin and Robert Xiao</em>
              <br></br>CHI 2023 [<a href="https://dl.acm.org/doi/10.1145/3544548.3580947" target="_blank">pdf</a>]
            </p>
          </div>
          <div className = "pubLabel">
            <h3>2022</h3>
          </div>
          <div className = "pubPubs">
            <p> <strong>Reducing the Latency of Touch Tracking on Ad-hoc Surfaces </strong>
              <br></br><em>Neil Fan and Robert Xiao</em>
              <br></br>ISS 2022 [<a href="https://dl.acm.org/doi/10.1145/3567730" target="_blank">pdf</a>]
            </p>
            <p> <strong>How Should I Respond to “Good Morning?”: Understanding Choice in Narrative-Rich Games </strong>
              <br></br><em>Michael Yin and Robert Xiao</em>
              <br></br>DIS 2022 <em>(Honorable Mention)</em> [<a href="https://dl.acm.org/doi/10.1145/3532106.3533459" target="_blank">pdf</a>]
            </p>
            <p> <strong>The Reward for Luck: Understanding the Effect of Random Reward Mechanisms in Video Games on Player Experience </strong>
              <br></br><em>Michael Yin and Robert Xiao</em>
              <br></br>CHI 2022 [<a href="https://dl.acm.org/doi/10.1145/3491102.3517642" target="_blank">pdf</a>]
            </p>
            <p> <strong>Learned Acoustic Reconstruction Using Synthetic Aperture Focusing </strong>
              <br></br><em>Tim Straubinger, Robert Xiao and Helge Rhodin</em>
              <br></br>ICASSP 2022 [<a href="https://ieeexplore.ieee.org/document/9746645" target="_blank">pdf</a>]
            </p>
          </div>
          <div className = "pubLabel">
            <h3>2021</h3>
          </div>
          <div className = "pubPubs">
            <p> <strong>PAIR: Phone as an Augmented Immersive Reality Controller </strong>
              <br></br><em>Arda Ege Unlu and Robert Xiao</em>
              <br></br>VRST 2021 [<a href="https://dl.acm.org/doi/abs/10.1145/3489849.3489878" target="_blank">pdf</a>]
            </p>
          </div>


        </div>
        {/* <div className = "pubFooter"></div> */}
      </div>
    )
  }
}

export default Pubs;
